var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.state.messageText != '')?_c('div',{class:this.alertClass},[_vm._v("\n     "+_vm._s(_vm.$store.state.messageText)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }